
const digest = 'f5344010b9a58029b3164a5c693bdcffd39185c4fb94f9d96afe9a24849cfa23';
const classes = {"wrapper":"_wrapper_xbsdy_1"};
const css = `._wrapper_xbsdy_1 {
  margin: -34px -24px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  background: rgb(220, 233, 250);
  padding: 24px 24px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  